<div id="quickActions">
  <ul *ngIf="!scriptRedirect.done">
    <li *ngIf="display.size !== 'xsmall'">
      <button (click)="validateScriptRedirection()" class="quickActionIcon" [disabled]="!canValidateScriptRedirect">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_check"></span>
        <span class="quickActionLabel">{{ 'agent:contact.actions.validate_script_redirection' | translate }}</span>
      </button>
    </li>
    <li *ngIf="!scriptRedirect.inProgress && display.size !== 'xsmall'">
      <button (click)="cancelScriptRedirection()" class="quickActionIcon">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_annuler"></span>
        <span class="quickActionLabel">{{ 'agent:contact.actions.cancel_script_redirection' | translate }}</span>
      </button>
    </li>
    <li *ngIf="display.size === 'xsmall'">
      <button class="quickActionIcon" (click)="toggleMoreMenu = !toggleMoreMenu" [attr.aria-expanded]="toggleMoreMenu">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_menu_bullets"></span>
        <span class="quickActionLabel">{{ 'commons:basic.actions' | translate }}</span>
      </button>
      <div class="quickActions-moreMenu" *ngIf="toggleMoreMenu" (mouseleave)="toggleMoreMenu = false">
        <ul>
          <li class="mainAction cng-ico_check">
            <button (click)="validateScriptRedirection()">
              {{ 'agent:contact.actions.validate_script_redirection' | translate }}
            </button>
          </li>
          <li class="mainAction cng-ico_annuler" *ngIf="!scriptRedirect.inProgress">
            <button (click)="cancelScriptRedirection()">
              {{ 'agent:contact.actions.cancel_script_redirection' | translate }}
            </button>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  <ul *ngIf="scriptRedirect.done">
    <li>
      <button (click)="unparkContactAndAgent()" class="quickActionIcon">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_help"></span>
        <span class="quickActionLabel">{{ 'agent:contact.actions.unpark_csr_contact' | translate }}</span>
      </button>
    </li>
  </ul>
</div>
